<template>
  <div id="cr_cra_list">
    <template>
      <div>
        <v-data-table
          :options.sync="options"
          :server-items-length="totalItems"
          :headers="headers"
          :items="forms"
          :search="search_form"
          :loading="loading"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50, 100],
          }"
          :items-per-page="20"
          class="elevation-1"
        >
          <template v-slot:top>
            <!-- <v-subheader>Zoznam CRA Formulárov</v-subheader>
            <v-divider></v-divider> -->

            <v-layout class="pa-3">
              <v-text-field
                v-model="search_form"
                label="Vyhľadať"
              />

              <v-switch
                v-model="multiple_forms"
                class="pl-12 pr-5"
                label="Viacnásobné"
              />
              <v-switch
                v-model="opened_only"
                class="pr-2"
                label="Neuzavreté"
              />
            </v-layout>
          </template>

          <template v-slot:[`item.closed`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.rizikove_faktory_full.closed"
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-close
                </v-icon>
              </template>
              <span v-if="item.assigned_to_socialny_pracovnik_full">{{
                item.assigned_to_socialny_pracovnik_full.string_details
              }}</span>
              <span v-else>Nepridelené</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.penitenciarne_zaobchadzanie_full.closed"
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-close
                </v-icon>
              </template>
              <span v-if="item.assigned_to_pedagog_full">{{
                item.assigned_to_pedagog_full.string_details
              }}</span>
              <span v-else>Nepridelené</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.psychologicke_vysetrenie_full.closed"
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-close
                </v-icon>
              </template>
              <span v-if="item.assigned_to_psycholog_full">{{
                item.assigned_to_psycholog_full.string_details
              }}</span>
              <span v-else>Nepridelené</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.poznatky_pbs_full.closed"
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-close
                </v-icon>
              </template>
              <span v-if="item.assigned_to_pbs_full">{{
                item.assigned_to_pbs_full.string_details
              }}</span>
              <span v-else>Nepridelené</span>
            </v-tooltip>

            <span v-if="item.version == 1">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="item.nahodne_overenie_full.closed"
                    small
                    class="mr-1"
                    v-on="on"
                  >mdi-check</v-icon>
                  <v-icon
                    v-else
                    small
                    class="mr-1"
                    v-on="on"
                  >mdi-close</v-icon>
                </template>
                <span v-if="item.assigned_to_pripadovy_manazer_full">{{
                  item.assigned_to_pripadovy_manazer_full.string_details
                }}</span>
                <span v-else>Nepridelené</span>
              </v-tooltip>
            </span>

            <span v-if="item.type == 'RU'">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-if="item.socialny_kurator_full.closed"
                    small
                    class="mr-1"
                    v-on="on"
                  >mdi-check</v-icon>
                  <v-icon
                    v-else
                    small
                    class="mr-1"
                    v-on="on"
                  >mdi-close</v-icon>
                </template>
                <span v-if="item.assigned_to_socialny_kurator_full">{{
                  item.assigned_to_socialny_kurator_full.string_details
                }}</span>
                <span v-else>Nepridelené</span>
              </v-tooltip>
            </span>

            <v-icon
              v-if="item.closed"
              large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              large
            >
              mdi-close
            </v-icon>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-icon
              small
              class="mr-3"
              @click="editItem(item)"
            >
              mdi-eye
            </v-icon>
            <v-icon
              small
              class="mr-3"
              @click="historyItem(item)"
            >
              mdi-account-badge-outline
            </v-icon>
            <v-icon
              v-if="canDelete(item)"
              small
              color="red"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>

        <v-btn
          fab
          bottom
          left
          color="pink"
          dark
          fixed
          @click="dialog = !dialog"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </template>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title>Nový CRA formulár</v-card-title>
        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-autocomplete
                v-model="item_new.prisoner"
                item-text="string_details"
                item-value="id"
                prepend-icon="mdi-email"
                placeholder="Základné číslo"
                label="Základné číslo"
                :items="prisoners"
                auto-select-first
                :search-input.sync="search"
                cache-items
                :loading="loading_prisoners"
                hide-no-data
              />

              <v-autocomplete
                v-model="item_new.type"
                prepend-icon="mdi-ab-testing"
                placeholder="Typ"
                label="Typ"
                :items="types"
              />
              <v-autocomplete
                v-model="item_new.comment"
                item-text="string_details"
                item-value="id"
                prepend-icon="mdi-comment"
                placeholder="Dôvod vytvorenia"
                label="Dôvod vytvorenia"
                :items="reasons"
              />
              <v-select
                v-model="item_new.version"
                prepend-icon="mdi-wheel-barrow"
                placeholder="Verzia"
                label="Verzia"
                :items="[2]"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >
            Zrušiť
          </v-btn>
          <v-btn
            text
            @click="createCrCra"
          >
            Vytvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";
import auth from "@/api/auth";

const apiService = new APIService();

export default {
  data: () => ({
    timeout: null,
    multiple_forms: false,
    dialog: false,
    loading: true,
    loading_prisoners: false,
    search_form: "",
    search: null,
    totalItems: 0,
    options: {},
    opened_only: true,

    filters: {
      "institution_full.name": [],
    },

    headers: [
      {
        text: "Interné ID",
        value: "id",
      },
      { text: "Základné číslo", value: "prisoner_full.base_number" },
      { text: "Meno", value: "prisoner_full.name_full" },

      { text: "Ústav", value: "institution_full.name" },
      {
        text: "Administrátor",
        value: "assigned_to_socialny_pracovnik_full.username",
      },
      { text: "Skóre", value: "score" },
      { text: "Typ", value: "type" },
      { text: "Vytvorený", value: "created_at" },
      { text: "Posledná zmena", value: "updated_at" },
      { text: "Stav", value: "closed" },
      { text: "Akcie", value: "action", sortable: false },
    ],

    forms: [],

    item_new: {
      prisoner: "",
      type: "",
      comment: "",
      version: 2,
    },
    prisoners: [],
    types: ["CR", "RU"],
    reasons: [
      "konanie o podmienečnom prepustení",
      "návrh riaditeľa ústavu na podmienečné prepustenie odsúdeného s nariadenou technickou kontrolou",
      "návrh na uloženie ochranného dohľadu",
      "konanie o žiadosti o milosť",
      "hodnotenie odsúdeného pred umiestnením do VODD",
      "návrh na umiestnenie do detenčného ústavu",
      "konanie o premene zvyšku trestu odňatia slobody na trest domáceho väzenia"
    ],
  }),

  watch: {
    search(val) {
      val && this.querySelections(val);
    },
    opened_only() {
      this.getDataFromApi();
    },
    multiple_forms() {
      this.getDataFromApi();
    },
    search_form() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getDataFromApi();
      }, 500);
    },
    options: {
      handler() {
        this.getDataFromApi();
      },
    },
    deep: true,
  },
  created() {
    auth.getAccountDetails().then((response) => {
      this.user_pk = response.data.pk;
    });
  },

  methods: {
    canDelete(item) {
      if (item.permissions.delete) return true;

      return false;
    },

    getClosed(item) {
      if (item == true) return "uzavretý";
      else return "otvorený";
    },
    getColor(item) {
      if (item == true) return "white";
      else return "red";
    },

    createCrCra() {
      apiService.createCraForm(this.item_new).then(
        (response) => {
          this.dialog = false;
          this.$router.push({
            name: `crcra_admin_v${response.version}`,
            params: { id: response.id },
          });
        },
      );
    },

    getCraForms(sort, search, limit, offset, filters) {
      this.loading = true;

      if (this.multiple_forms) {
        apiService
          .getCraMultipleForms(sort, search, limit, offset, filters)
          .then((response) => {
            this.forms = response.results;
            this.totalItems = response.count;
            this.loading = false;
          });
      } else {
        apiService
          .getCraForms(sort, search, limit, offset, filters)
          .then((response) => {
            this.forms = response.results;
            this.totalItems = response.count;
            this.loading = false;
          });
      }
    },

    editItem(item) {
      this.$router.push({
        name: `crcra_uvod_v${item.version}`,
        params: { id: item.id },
      });
    },

    historyItem(item) {
      this.$router.push({ name: "crcra_history", params: { id: item.id } });
    },

    async deleteItem(item) {
      confirm("Naozaj chcete zmazať?") &&
        apiService.deleteCraForm(item).then(() => {
          const index = this.forms.indexOf(item);
          this.forms.splice(index, 1);
        });
    },

    querySelections(v) {
      this.loading_prisoners = true;

      apiService.searchPrisoners(v).then((response) => {
        this.prisoners = response.results;
        this.loading_prisoners = false;
      });
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0].replace(/\./g, "__").replace(/_full/g, "");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      if (this.opened_only) {
        this.getCraForms(sort, this.search_form, itemsPerPage, offset, [
          ["closed", false],
        ]);
      } else {
        this.getCraForms(sort, this.search_form, itemsPerPage, offset);
      }
    },
  },
};
</script>